import { useEffect, useState } from "react";
import withLoader from "../../../../components/layouts/WithLoader";
import UtilsFormule from "../../../../utils/UtilsFormule";
import { TextField } from "@material-ui/core";
import KpiProductionService from "../../../../services/Production/KpiProductionService";
import getCurrentUserId from "../../../../reduxSaga/sagas/requests/currentUserId";

const KPIProductionOrder = ({ startLoading, stopLoading }) => {
  const today = UtilsFormule.formatDateJournal(new Date());
  const [dateBegin, setDateBegin] = useState(today);
  const [dateEnd, setDateEnd] = useState(today);
  const [btnClear, setBtnClear] = useState(false);
  const [availableStats, setAvailableStats] = useState([]);

  useEffect(() => {
    fetchProductionStats(dateBegin, dateEnd);
  }, []);

  const fetchProductionStats = (startDate, endDate) => {
    setAvailableStats([])
    startLoading();
    KpiProductionService.getProductionStateByDateBetween(
      getCurrentUserId(),
      startDate.concat("T00:00:00"),
      endDate.concat("T23:59:59")
    )
      .then((response) => {
        if (response?.data?.success) {
          setAvailableStats(response.data.success);
        }
      })
      .catch((error) => {
        console.error("Error fetching production stats:", error);
      })
      .finally(() => {
        stopLoading();
      });
  };

  const onGetStats = () => {
    fetchProductionStats(dateBegin, dateEnd);
    // setBtnClear(true);
  };

  const onChangeDateBegin = (event) => {
    setDateBegin(event.target.value);
  };

  const onChangeDateEnd = (event) => {
    setDateEnd(event.target.value);
  };

  const onClearFilters = () => {
    setBtnClear(false);
    setDateBegin(today);
    setDateEnd(today);
    fetchProductionStats(today, today);
  };
  const renderWorkStationStats = (workStations) => {
    if (!workStations || workStations.length === 0) {
      return <div className="alert alert-info">Aucune station de travail disponible</div>;
    }

    return (
      <div className="card card-success">
        <div className="card-header">
          <h3 className="card-title">Statistiques par Station de Travail</h3>
        </div>
        <div className="card-body p-0">
          <table className="table table-striped">
            <thead>
              <tr>
                <th>Station</th>
                <th>Code</th>
                <th>Équipes</th>
                <th>Dépôt Entrée</th>
                <th>Dépôt Sortie</th>
                <th>En attente</th>
                <th>Démarrées</th>
                <th>Terminées</th>
              </tr>
            </thead>
            <tbody>
              {workStations.map((station, index) => (
                <tr key={index}>
                  <td>{station.workstation.name}</td>
                  <td>{station.workstation.code}</td>
                  <td>
                    {station.workstation.crews.map(crew => crew.nomEquipe).join(', ')}
                  </td>
                  <td>{station.workstation.warehouseEntreeName}</td>
                  <td>{station.workstation.warehouseSortieName}</td>
                  <td>{station.workOrderCountByWorkStation.PENDING}</td>
                  <td>{station.workOrderCountByWorkStation.STARTED}</td>
                  <td>{station.workOrderCountByWorkStation.FINISHED}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  };
  const renderDepartmentStats = (departments) => {
    if (!departments || departments.length === 0) {
      return <div className="alert alert-info">Aucun département disponible</div>;
    }

    return (
      <div className="card card-primary">
        <div className="card-header">
          <h3 className="card-title">Statistiques par Département</h3>
        </div>
        <div className="card-body p-0">
          <table className="table table-striped">
            <thead>
              <tr>
                <th>Département</th>
                <th>Chef de Département</th>
                <th>Ordre de production Confirmées</th>
                <th>Ordre de production Démarrées</th>
                <th>Ordre de production Terminées</th>
              </tr>
            </thead>
            <tbody>
              {departments.map((dept, index) => (
                <tr key={index}>
                  <td>{dept.department.nomDept}</td>
                  <td>
                    {dept.department.chefDept?.firstName} {dept.department.chefDept?.lastName}
                  </td>
                  <td>{dept.productionOrderCountByDepartement.CONFIRMED}</td>
                  <td>{dept.productionOrderCountByDepartement.STARTED}</td>
                  <td>{dept.productionOrderCountByDepartement.FINISHED}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  };
  const renderEmployeeProductivity = (productivity) => {
    if (!productivity || !productivity.productiviteEmployeeByUserList) {
      return <p>Aucune donnée de productivité disponible</p>;
    }

    return (
      <div className="card card-info">
        <div className="card-header">
          <h3 className="card-title">Productivité des Employés</h3>
        </div>
        <div className="card-body p-0">
          <table className="table table-striped">
            <thead>
              <tr>
                <th>Employé</th>
                <th>Matricule</th>
                <th>Nombre de Pièces</th>
              </tr>
            </thead>
            <tbody>
              {productivity.productiviteEmployeeByUserList.map((item, index) => (
                <tr key={index}>
                  <td>{item.user.firstName} {item.user.lastName}</td>
                  <td>{item.user.matricule}</td>
                  <td>{item.nbPieces.toLocaleString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <div className="card card-dark">
            <div className="card-body">
              <h5 className="card-title">
                Les Statistiques des ordres de production
              </h5>
              <br />
              <div className="row">
                <p>
                  <small>
                    Initialement, il y avait les statistiques des ordres de
                    production pour ce jour{" "}
                    <b>{UtilsFormule.formatDate(new Date())}</b>.
                  </small>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="content">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">
              <div className="card card-dark">
                <div className="card-body">
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label htmlFor="dateBegin">Date début</label>
                        <TextField
                          style={{ width: "100%" }}
                          className="col-sm-12"
                          variant="outlined"
                          value={dateBegin}
                          onChange={onChangeDateBegin}
                          id="dateBegin"
                          type="date"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          size="small"
                        />
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label htmlFor="dateEnd">Date fin</label>
                        <TextField
                          style={{ width: "100%" }}
                          className="col-sm-12"
                          variant="outlined"
                          value={dateEnd}
                          onChange={onChangeDateEnd}
                          id="dateEnd"
                          type="date"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          size="small"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-footer">
                  <div className="row">
                    {/* {btnClear && (
                      <div className="col-sm-6 text-center">
                        <button
                          className="btn btn-dark"
                          onClick={onClearFilters}
                        >
                          Annuler Filtre
                        </button>
                      </div>
                    )} */}
                    <div
                      className="col-sm-12 text-center"
                    >
                      <button
                        className="btn btn-dark"
                        onClick={onGetStats}
                      >
                        Valider le choix
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="content">
        <div className="container-fluid">
          
          <div className="row">
          <div className="col-sm-12">
            {/* {availableStats && availableStats.map((element, index) => (
              <div key={index} className="card ">
                <div className="card-header">
                  <h4 className="card-title">
                    <button
                      className="btn btn-link "
                      style={{color:"black"}}
                      data-toggle="collapse"
                      data-target={`#collapse-${index}`}
                    >
                   Statistiques du jour:   {element?.dayState}
                    </button>
                  </h4>
                </div>
                <div id={`collapse-${index}`} className="collapse">
                  <div className="card-body">
                    "Aucun détail disponible pour cette période."
                  </div>
                </div>
              </div>
            ))} */}
             {availableStats.map((stat, index) => (
          <div key={index} className="row mb-4">
          <div className="col-md-12">
            <div className="card card-warning collapsed-card">
              <div className="card-header">
                <h2 className="card-title">
                  Statistiques de production pour le {stat.dayState}
                </h2>
                <div className="card-tools">
                  <button 
                    type="button" 
                    className="btn btn-tool" 
                    data-card-widget="collapse"
                  >
                    <i className="fas fa-plus" />
                  </button>
                </div>
              </div>
              <div className="card-body" style={{display: 'none'}}>
                <div className="row">
                  <div className="col-md-12 mb-4">
                    {renderEmployeeProductivity(stat.productiviteEmployee)}
                  </div>
                </div>
                
                <div className="row">
                  <div className="col-md-12 mb-4">
                    {renderDepartmentStats(stat.productionOrderCountByDepartementList)}
                  </div>
                </div>
                
                <div className="row">
                  <div className="col-md-12">
                    {renderWorkStationStats(stat.workOrderCountByWorkStationList)}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
          ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default withLoader(KPIProductionOrder);